export const loginSettingsReducer = (state={}, action) => {
	switch (action.type) {
		case 'SET_LOGIN_SETTINGS':
			return {...action.payload};
		default:
			return state;
	}
}